import { preloadModule, deferred } from '../../utils/preload';

/* Dashboard cards below the first screen on a phone (~14 KB gzipped), out of the main
   bundle. Fetched at startup, in parallel with the sign-in check, so they are in
   before the Dashboard renders (utils/preload.js). Same props as the real cards. */
const belowFold = preloadModule(() => import(/* webpackChunkName: "dashboard-below" */ './belowFold'));

export const LightsControl = deferred(belowFold, 'LightsControl');
export const TodayCard = deferred(belowFold, 'TodayCard');
export const HarvestForecastCard = deferred(belowFold, 'HarvestForecastCard');
export const PowerTodayCard = deferred(belowFold, 'PowerTodayCard');
export const RackPhotosStrip = deferred(belowFold, 'RackPhotosStrip');
